import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Loader from "components/loader";
import { SET_DELIVERY_FREQUENCY } from "utils/action-types";
import { useGlobalContext } from "context/global";
import { beginCheckout } from "actions/cart";
import { trackSelectedMealPlan } from "services/analytics";
import ErrorHoverButton from "components/error-hover-button";

const CheckoutButton = ({ bundle, className = "", buttonText, onPreCheckout }) => {
	const { subscriptionId } = useSelector(state => state.account.subscription);
	const {
		delivery, mealsPerWeek, activeBox, totalProgress, totalQuantity, allGiftCards, checkoutLoading
	} = useSelector(state => state.cart);
	const {
		translation, langCode, cartSettings: { min_products_required, subscription }, isOneTimeCollection
	} = useGlobalContext();
	const dispatch = useDispatch();

	useEffect(() => {
		const defaultFrequency =
			subscription.frequencies.find(freq => freq.interval === "WEEK" && freq.intervalCount === 4) ||
			subscription.frequencies[0];

		if (!delivery.intervalCount)
			dispatch({ type: SET_DELIVERY_FREQUENCY, payload: defaultFrequency });
	}, []);

	//If a bundle exists, isCheckoutDisabled depends if the user has subscription or not, but if not, it follows usual cart conditions.
	let isCheckoutDisabled = bundle ? subscriptionId :
		!activeBox || totalProgress < min_products_required ||
		activeBox?.size?.value > totalProgress || subscriptionId;

	if (totalQuantity && allGiftCards)
		isCheckoutDisabled = false;

	const checkout = async () => {
		if (isCheckoutDisabled) return;
		onPreCheckout && await onPreCheckout();

		if (!isOneTimeCollection)
			trackSelectedMealPlan(activeBox, mealsPerWeek, delivery);

		dispatch(beginCheckout(langCode, isOneTimeCollection, subscription.discountCode, bundle?.sellingPlanId));
	};

	let errorMessage = "";

	if (subscriptionId && !isOneTimeCollection)
		errorMessage = translation.cart?.only_one_subscription_allowed;
	else if (activeBox?.size?.value > totalProgress)
		errorMessage = translation.cart?.add_bowls_to_checkout?.replace(`{value}`, (activeBox?.size?.value - totalQuantity));

	return (
		<div className="w-full flex flex-col justify-center items-center">
			{checkoutLoading ? <Loader ring /> :
				<ErrorHoverButton
					id="checkout-button"
					errorMessage={errorMessage} text={buttonText || translation.cart?.checkout}
					isDisabled={isCheckoutDisabled} onClick={checkout} className={className}
				/>}
		</div>
	);
};

export default CheckoutButton;
